import React from 'react';
import MaskedInput from 'react-text-mask';

import { DATE_PIPE, MASK } from './DatePickerInput.constants';

import { Input } from '../Input';
import { Icon } from '../Icon';
import { Popover } from '../Popover';
import { DatePicker } from '../DatePicker';

import styles from './DatePickerInput.styles.scss';

const DatePickerInput = ({
  visible,
  inputRef,
  disabledDays,
  value,
  onTriggerPickerClick,
  onOutsidePickerClick,
  onDayClick,
  toYear,
  disabled,
  ...restProps
}) => (
  <MaskedInput
    {...restProps}
    disabled={disabled}
    keepCharPositions
    pipe={DATE_PIPE}
    mask={MASK}
    guide={false}
    placeholderChar=" "
    value={value}
    render={(ref, props) => (
      <Input
        {...props}
        readOnly
        inputRef={(element) => {
          ref(element);

          if (inputRef) {
            inputRef.current = element;
          }
        }}
      />
    )}
    startAdornment={
      <Popover
        mode="controlled"
        visible={visible}
        interactive
        appendTo={() => document.body}
        content={
          <div>
            <DatePicker
              toYear={toYear}
              disabledDays={disabledDays}
              onDayClick={onDayClick}
            />
          </div>
        }
        onOutsideClick={onOutsidePickerClick}
        onTriggerClick={onTriggerPickerClick}
      >
        {({ onTriggerClick }) => (
          <span onClick={!disabled ? onTriggerClick : null}>
            <Icon className={styles.icon} name="calendar" />
          </span>
        )}
      </Popover>
    }
  />
);

export default React.memo(DatePickerInput);
